// extracted by mini-css-extract-plugin
module.exports = {"img_ad_b":"img_ad_b-2_FDta_b"};